angular.module("manager").factory("EnvironmentService", ["$http", "ENV", function ($http, ENV) {

	var ENTITY = "/environments";

	/**
     * API
     */
	return {
		copyEnvironment: copyEnvironment,
		deleteEnvironment: deleteEnvironment,
		pullEnvironment: pullEnvironment,
		truncateEnvironment: truncateEnvironment,
		analyzeImpactEnvironment: analyzeImpactEnvironment,
		replaceEnvironment: replaceEnvironment,
		depannageEnvironment: depannageEnvironment,
		downloadAnalyzeImpactEnvironment: downloadAnalyzeImpactEnvironment,
		prepareEnvironment: prepareEnvironment
	};


	/**
	 * Dupliquer le schéma
	 * @returns {HttpPromise}
	 */
	function copyEnvironment(id, newEnvironment) {
		return $http.post(ENV.API_URL + ENTITY + "/" + id + "/duplicate", newEnvironment);
	}

	/**
	 * Supprimer le schéma
	 * @returns {HttpPromise}
	 */
	function deleteEnvironment(id) {
		return $http.delete(ENV.API_URL + ENTITY + "/" + id);
	}

	/**
	 * Vider le schéma
	 * @returns {HttpPromise}
	 */
	function truncateEnvironment(id, withTopology) {
		return $http.get(ENV.API_URL + ENTITY + "/" + id +"/clean?keep-topology=" + withTopology);
	}


	function depannageEnvironment(id) {
		return $http.get(ENV.API_URL + ENTITY + "/" + id +"/create-default-topology");
	}

	/**
	 * Remplacer le schéma parent de l'actuel
	 * @returns {HttpPromise}
	 */
	function replaceEnvironment(id) {
		return $http.get(ENV.API_URL + ENTITY + "/" + id +"/replace-environment");
	}

	/**
	 * Préparer le schéma school-iti
	 * @returns {HttpPromise}
	 */
	function prepareEnvironment(id) {
		return $http.get(ENV.API_URL + ENTITY + "/" + id +"/reset-schooliti");
	}

	/**
	 * Récupérer les abonnés, tarifs, factures, ...
	 * @returns {HttpPromise}
	 */
	function pullEnvironment(id) {
		return $http.get(ENV.API_URL + ENTITY + "/" + id +"/subsribers-schooliti");
	}

	/**
	 * Impacts de la fusion
	 * @returns {HttpPromise}
	 */
	function analyzeImpactEnvironment(id, emailToSendReport, complete) {
		return $http.get(ENV.API_URL + ENTITY + "/" + id +"/analyze-impact-subscribers?email=" + emailToSendReport + "&complete=" + complete);
	}

	/**
	 * Télécharger le rapport
	 * @param id
	 * @returns {HttpPromise}
	 */
	function downloadAnalyzeImpactEnvironment(id) {
		return $http.get(ENV.API_URL + ENTITY + "/" + id +"/analyze-impact-subscribers/download");
	}

}]);
